import { X } from "lucide-react";
import { useState, useEffect } from "react";

const BreathingExercise = ({ isOpen, onClose }) => {
  const [phase, setPhase] = useState('breatheIn');
  const [count, setCount] = useState(4);
  const [circleScale, setCircleScale] = useState(0.5);

  useEffect(() => {
    if (!isOpen) {
      setPhase('breatheIn');
      setCount(4);
      setCircleScale(0.5);
      return;
    }
    
    const timer = setInterval(() => {
      setCount(prev => {
        if (prev <= 1) {
          setPhase(p => {
            const next = p === 'breatheIn' ? 'breatheOut' : 'breatheIn';
            return next;
          });
          return 4;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen]);

  // Smoothly animate circle scale based on phase and count
  useEffect(() => {
    if (!isOpen) return;
    if (phase === 'breatheIn') {
      setCircleScale(0.5 + ((4 - count) / 4) * 0.5);
    } else {
      setCircleScale(1.0 - ((4 - count) / 4) * 0.5);
    }
  }, [phase, count, isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-[80] p-4"
      data-testid="breathing-exercise-container"
      onClick={onClose}
    >
      <div className="bg-[#FDFBF7] rounded-3xl p-8 sm:p-12 max-w-md w-full text-center shadow-2xl relative" onClick={(e) => e.stopPropagation()}>
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-[#6B6B6B] hover:text-[#4A4A4A] transition-colors"
          data-testid="breathing-close-button"
        >
          <X className="w-8 h-8" />
        </button>
        
        <h2 className="text-2xl sm:text-3xl font-bold text-[#4A4A4A] mb-8">
          Let's breathe together
        </h2>
        
        <div className="relative w-48 h-48 sm:w-56 sm:h-56 mx-auto mb-8 flex items-center justify-center">
          <div 
            className="absolute rounded-full bg-gradient-to-br from-[#E6F0F9] to-[#C9DFE9] transition-all duration-900 ease-in-out"
            style={{ 
              width: `${circleScale * 100}%`, 
              height: `${circleScale * 100}%`,
              opacity: 0.7 + circleScale * 0.3
            }}
          ></div>
          <div 
            className="absolute rounded-full bg-gradient-to-br from-[#FFF7D6] to-[#FCEB9C] transition-all duration-900 ease-in-out"
            style={{ 
              width: `${circleScale * 80}%`, 
              height: `${circleScale * 80}%`,
              opacity: 0.7 + circleScale * 0.3
            }}
          ></div>
          <div className="relative z-10 flex items-center justify-center">
            <span className="text-5xl sm:text-6xl font-bold text-[#4A4A4A]">{count}</span>
          </div>
        </div>
        
        <p className="text-2xl sm:text-3xl font-semibold text-[#4A7AA5]">
          {phase === 'breatheIn' ? 'Breathe in...' : 'Breathe out...'}
        </p>
        
        <p className="text-lg text-[#6B6B6B] mt-4">
          You're doing great! 💛
        </p>
      </div>
    </div>
  );
};

export default BreathingExercise;
